export const workerPerformanceLink = {
  label: 'Worker Performance',
  to: '/comms/stats',
} as const
